import { useState, useEffect, useRef } from 'react';
import '../styles/Contact.css';
import { SocialNetworks } from '../components/ui/SocialNetworks.jsx';
import iconCheck from '../assets/check.svg';
import iconLoading from '../assets/loading.svg';

export function Contact(){

  const [loading, setLoading] = useState(false);
  const [checkClasses, setCheckClasses] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const timers = useRef([]);

  const clearTimers = () => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  }

  useEffect(() => clearTimers, []);

  const sendMail = (e) => {
    e.preventDefault();
    const $form = e.currentTarget;

    clearTimers();
    setCheckClasses("");
    setLoading(true);

    fetch("https://formsubmit.co/ajax/cferbece@gmail.com", {
      method: "POST",
      body: new FormData($form)
    })
    .then((res) => (res.ok ? res.json() : Promise.reject(res)))
    .then(() => {
      $form.reset();
      setErrorMessage("");
    })
    .catch((err) => {
      setErrorMessage(err.statusText || "Ocurrió un error");
    })
    .finally(() => {
      setCheckClasses("modal-active");
      timers.current.push(setTimeout(() => setLoading(false), 2000));
      timers.current.push(setTimeout(() => setCheckClasses("modal-active modal-active-down"), 2150));
      timers.current.push(setTimeout(() => setCheckClasses(""), 4150));
    });
  }

  return(
    <section id="contact" className="contact">
      <h3 className="title">Contacto</h3>

      <div className="contact-content">
        <p className="text">
          ¿Quieres digitalizar un servicio o modernizar un sistema en tu institución o empresa? <br />
          Puedes contactarme enviando un mail a <a href="mailto:cferbece@gmail.com">cferbece@gmail.com</a> o a través de mis redes sociales. <br />
          <u>¡Espero tu mensaje!</u>
        </p>

        <SocialNetworks />

        <form action="https://formsubmit.co/ajax/cferbece@gmail.com" className="contact-form" onSubmit={sendMail}>
          <input title="Ingresa tu nombre" className="contact-input-text" type="text" name="name" placeholder="Ingresa tu nombre" pattern="^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$" required />
          <input title="Ingresa tu correo" className="contact-input-text" type="email" name="email" placeholder="Ingresa tu correo" pattern="^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$" required />

          <textarea title="Ingresa tu mensaje" name="message" placeholder="Ingresa tu mensaje" required></textarea>

          <button type="submit" title="Enviar" className="form-send-btn" disabled={loading}>Enviar</button>
        </form>

        <article className={`modal-check ${checkClasses}`.trim()} role="status" aria-live="polite">
          <img src={iconCheck} alt="Enviado" />
          <h5>{errorMessage ? errorMessage : <>¡Gracias!<br/>Recibí tu mensaje</>}</h5>
        </article>

        <article className={loading ? "modal-loading modal-active" : "modal-loading"}>
          <img src={iconLoading} alt="Enviando" className="icon-loading" />
          <h5>Enviando...</h5>
        </article>

      </div>
    </section>
  );
}
